<template>
  <div id="searchStage" class="d-flex align-items-center">
    <h5 class="mb-0">et j'ai à ce jour</h5>

    <multiselect
      :class="{ 'border-bottom-blue': isSearchStageSet && !isOpened }"
      ref="multiselect"
      v-model="searchStageValue"
      :options="searchStageOptions"
      placeholder="fait une offre"
      :searchable="false"
      :multiple="false"
      :allow-empty="false"
      :close-on-select="true"
      :show-labels="false"
      @close="isOpened = false"
      @open="isOpened = true"
    >
      <span
        class="caret"
        slot-scope="{ toggle }"
        :class="{ 'border-blue': isSearchStageSet }"
        @mousedown.prevent.stop="toggle"
        slot="caret"
      ></span>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      isOpened: false,
      searchStageOptions: [
        "uniquement fait une visite",
        "fait une offre",
        "signé le compromis",
        "signé l'acte de vente",
      ],
    };
  },
  computed: {
    searchStageValue: {
      get() {
        return this.$store.state.optionalFields.searchStage;
      },
      set(value) {
        this.$store.commit("SET_SEARCH_STAGE", value);
      },
    },
    ...mapGetters(["isSearchStageSet"]),
  },
  methods: {
    focus() {
      this.$refs.multiselect.$el.focus();
    },
  },
  mounted() {
    this.focus();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/multiselect.scss";
.multiselect {
  width: 18rem;
  margin-left: 1rem;
  margin-right: 1rem;
}
</style>
